import { render, staticRenderFns } from "./ZohoLoginButton.vue?vue&type=template&id=39c0045b"
import script from "./ZohoLoginButton.vue?vue&type=script&lang=js"
export * from "./ZohoLoginButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports